import type { BaseProps } from '../interfaces';

import { forwardRef, useCallback } from 'react';
import { useRouter } from 'next/router';

import { StyledNavbarMenu, StyledNavbarMenuItem } from './_Base';

export interface NavbarMenuItem {
  key: string;
  text: string;
  href: string;
  active?: boolean;
  disabled?: boolean;
  hidden?: boolean;
}

interface NavbarMenuProps extends BaseProps {
  data?: NavbarMenuItem[];
}

export const NavbarMenu = forwardRef<HTMLElement, NavbarMenuProps>((props, ref) => {
  const router = useRouter();
  const { data = [], ...restProps } = props;

  const handleNavbarMenuClick = useCallback(
    (item: NavbarMenuItem) => {
      if (item.disabled) {
        return;
      }

      router.push(item.href);
    },
    [router],
  );

  return (
    <StyledNavbarMenu ref={ref} {...restProps}>
      {data
        .filter((item) => !item.hidden)
        .map((item) => (
          <StyledNavbarMenuItem
            key={item.key}
            active={item.active}
            disabled={item.disabled}
            onClick={() => handleNavbarMenuClick(item)}
          >
            {item.text}
          </StyledNavbarMenuItem>
        ))}
    </StyledNavbarMenu>
  );
});

NavbarMenu.displayName = 'NavbarMenu';
